import { inject, Injectable, InjectionToken } from '@angular/core';
import { APIService } from '../APIService/api.service';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { firstValueFrom } from 'rxjs';
import { TitleAndFileNames } from 'src/app/content/_components/_shared/mediaviewmodal/mediaviewmodal.component';
import { FileByNameFn, FilesByNamesFn, MediaApiFunc } from 'src/app/services/MediaApiFunc/abstract-media-api-func';

export const MEDIA_TITLE = new InjectionToken<string>('TitleAndFileNames - Title', { factory: () => 'Anlagen' });

@Injectable({
  providedIn: 'root',
})
export class AnlagenMediaApiFuncService extends MediaApiFunc {
  private readonly mrTranslate = inject(MrTranslatePipe);
  private readonly apiService = inject(APIService);

  private readonly title = inject(MEDIA_TITLE);
  constructor() {
    super();
  }

  parseMediaPath(anlagen: string): TitleAndFileNames[] {
    let fileNamesWithTitle: TitleAndFileNames[] = [];

    if (anlagen)
      fileNamesWithTitle.push({
        title: this.title,
        fileNames: anlagen.split('|').filter(bild => bild != ''),
      });
    return fileNamesWithTitle;
  }
  getApiFunctionMedia: FilesByNamesFn = async fileNames => {
    if (!fileNames?.length) return [];
    const { success, files, error } = await firstValueFrom(this.apiService.getAnlagenMediaAll(fileNames));
    if (!success)
      throw new Error(
        this.mrTranslate.transform('Die Dateien konnten nicht geladen werden!') +
          ' ' +
          this.mrTranslate.transform(error)
      );
    return files;
  };

  getApiFunctionMediaBig: FileByNameFn = async name => {
    if (!name) return;
    const base64 = await firstValueFrom(this.apiService.getAnlagenMedia(name));
    if (!base64) throw new Error(this.mrTranslate.transform('Die Datei konnte nicht geladen werden!'));
    return base64;
  };
}
